import * as z from "zod";

// "Valor Aportado" (ex-cota) — D5–D8 da parte 2 (03/09/2026), revisto em
// 24/09/2026.
//
// O campo Nome saiu em 03/09: o aporte se identifica por patrocinador + valor
// (D6). A CONTRAPARTIDA saiu em 24/09 (D4 de tasks/notificacoes_admin) — ela é
// cadastrada na sessão própria, e o texto livre `setbacks` nunca foi a tabela
// `counterparts`. Sobrou Valor + Seletiva.
const QuotaValidator = {
  value: z.coerce
    .number({
      message: "Número inválido",
      invalid_type_error: "Número inválido",
    })
    .or(z.string()),
};

export default QuotaValidator;
